<template>
    <KRHPPaigutus>
        <template #pais>
            <v-row>
                <v-col>
                    <VoHoiatus class="ma-2"></VoHoiatus>
                    <h1 class="px-2">Elektrooniline valve</h1>
                    <p class="px-2 text-textDark text-justify mt-3" v-if="lehePaiseTekst && lehePaiseTekstLuhendatud">
                        <VoKuvaRohkem :terveTekst="lehePaiseTekst" :luhendatudTekst="lehePaiseTekstLuhendatud">
                        </VoKuvaRohkem>
                    </p>
                </v-col>
            </v-row>
            <v-row v-if="isLoading">
                <v-col class="px-5">
                    <v-card>
                        <div class="text-center my-2">
                            <v-progress-circular indeterminate></v-progress-circular>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
            <template v-if="!isLoading">
                <v-row v-for="(tabel, i) in tabelid" :key="i">
                    <v-col class="pt-5 pb-0 d-none d-xl-block">
                        <v-data-table class="mt-4 rounded elevation-3" :expanded="tabel.laiendatud" show-expand
                            fixed-header single-expand :headers="tabel.suureEkraanipaised" :items="[tabel.element]"
                            :items-per-page="tabel.lehePikkus" :loading="isLoading" :row-props="rida_class"
                            item-key="id">
                            <template #expanded-row="{ columns }">
                                <tr>
                                    <td :colspan="columns.length">
                                        <v-data-table class="rounded elevation-3" :headers="tabel.sisuPaised"
                                            :items="tabel.tegevused" :items-per-page="tabel.lehePikkus"
                                            :loading="isLoading" fixed-header item-key="id" :cell-props="item_class"
                                            :row-props="rida_class">
                                            <template v-slot:[`item.tegevuseSisu`]="{ value, item }">
                                                <pre :id="item.id" class="pre">{{ value }}</pre><input type="hidden"
                                                    :value="scrollToEv()">
                                            </template>
                                            <template v-slot:bottom> </template>
                                        </v-data-table>
                                    </td>
                                </tr>
                            </template>
                            <template v-slot:[`item.periood`]="{ value }">
                                {{ formateeriKuupaev(value.algusKp) }} - {{ formateeriKuupaev(value.loppKp) }}
                            </template>
                            <template v-slot:[`header.hooldusaluseKinnitamiseKp`]="{ }">
                                <template v-if="tabel.element?.hooldusaluseKinnitamiseKp">
                                    Kinnitamise kp.
                                </template>
                            </template>
                            <template v-slot:[`item.hooldusaluseKinnitamiseKp`]="{ value, item }">
                                <hidden :id="item.id"></hidden>
                                <template v-if="value">{{ formateeriKuupaevaAjaga(value) }}</template>
                                <template v-if="!value && item">
                                    <v-btn absolute bottom left :loading="kinnitamisedIsLoading"
                                        @click="kinnitaEVAjakava(item)" color="primary">
                                        Kinnitan ajakava
                                    </v-btn></template>
                            </template>
                            <template v-slot:bottom> </template>
                        </v-data-table>
                    </v-col>
                    <v-col class="d-xl-none">
                        <v-row>
                            <v-col class="pt-5 pb-0" cols="auto">
                                <v-data-table class="mt-4 rounded elevation-3" width="300" :headers="tabel.paised"
                                    :items="[tabel.element]" :items-per-page="tabel.lehePikkus" :loading="isLoading"
                                    :row-props="rida_class" fixed-header item-key="id">

                                    <template v-slot:[`item.periood`]="{ value }">
                                        {{ formateeriKuupaev(value.algusKp) }} - {{ formateeriKuupaev(value.loppKp) }}
                                    </template>
                                    <template v-slot:[`header.hooldusaluseKinnitamiseKp`]="{ }">
                                        <template v-if="tabel.element?.hooldusaluseKinnitamiseKp">
                                            Kinnitamise kp.
                                        </template>
                                    </template>
                                    <template v-slot:[`item.hooldusaluseKinnitamiseKp`]="{ value, item }">
                                        <hidden :id="item.id"></hidden>
                                        <template v-if="value">{{ formateeriKuupaevaAjaga(value) }}</template>
                                        <template v-if="!value && item">
                                            <v-btn absolute bottom left :loading="kinnitamisedIsLoading"
                                                @click="kinnitaEVAjakava(item)" color="primary">
                                                Kinnitan ajakava
                                            </v-btn></template>
                                    </template>
                                    <template v-slot:bottom> </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="pb-5 pt-0">
                                <v-data-table class="rounded  elevation-3" :headers="tabel.sisuPaised"
                                    :items="tabel.tegevused" :items-per-page="tabel.lehePikkus" :loading="isLoading"
                                    fixed-header item-key="id" :cell-props="item_class" :row-props="rida_class">
                                    <template v-slot:[`item.tegevuseSisu`]="{ value, item }">
                                        <pre :id="item.id" class="pre">{{ value }}</pre><input type="hidden"
                                            :value="scrollToEv()">
                                    </template>
                                    <template v-slot:bottom> </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </template>
        </template>
    </KRHPPaigutus>
</template>

<style>
.pre {
    font-family: Roboto, sans-serif !important;
    white-space: pre-wrap;
    /* Since CSS 2.1 */
    white-space: -moz-pre-wrap;
    /* Mozilla, since 1999 */
    white-space: -pre-wrap;
    /* Opera 4-6 */
    white-space: -o-pre-wrap;
    /* Opera 7 */
    word-wrap: break-word;
    /* Internet Explorer 5.5+ */
}

.valitudRida {
    box-shadow: inset 2px 2px var(--varv-icon-2),
        inset -2px -2px var(--varv-icon-2);
}
</style>

<script lang="ts">
import { defineComponent, nextTick } from 'vue';
import KRHPPaigutus from './uldine/KRHPPaigutus.vue';
import mixin from '@/core/mixins';
import { ElektroonilineValveTeenus } from '@/core/elektrooniline-valve-teenus';
import { ElektroonilineValve, ElektroonilineValveTegevus } from '@/models/ElektrooonilineValve';
import moment from 'moment';

const _elektroonilineValveTeenus = new ElektroonilineValveTeenus();

export class tabeliMudel {
    laiendatud: any[] | undefined;
    paised: any[] | undefined;
    suureEkraanipaised: any[] | undefined;
    sisuPaised: any[] | undefined;
    element: ElektroonilineValve | undefined;
    tegevused: ElektroonilineValveTegevus[] | undefined;
    lehePikkus: number | undefined;
}

export default defineComponent({
    name: 'ElektroonilineValveLeht',
    components: { KRHPPaigutus },
    data() {
        return {
            isLoading: false,
            kinnitamisedIsLoading: false,
            tabelid: [] as tabeliMudel[],
            lehePaiseTekst: `<p class="py-3">Siin näete elektroonilise valve kehtivat ajakava. Elektrooniline valve on kriminaalhooldusalusele kohtu poolt määratud tähtajaks pandud kohustus alluda liikumisvabaduse piirangutele. Ametnik koostab koostöös Teiega elektroonilise valve ajakava.</p>
    <p class="py-3">Ajakavas kuvatakse liikumisi järgmiselt:</p>
    <ul class="px-4">      
        <li>peenikeses mustas kirjas on liikumised, mis on kinnitatud algse ajakavaga – kajastub elektroonilise valve süsteemis – Teie liikumine toimub kuvatud ajakava järgi;</li>
        <li>paksus mustas kirjas on uued liikumised, mis muudetud – kajastub elektroonilise valve süsteemis – Teie liikumine toimub kuvatud ajakava järgi;</li>
        <li>hallis kirjas kuvatakse liikumine, millele on muudatus tehtud – ametnik on need elektroonilise valve süsteemist eemaldanud, neid liikumisi ei toimu;</li>
        <li>läbikriipsutatult kuvatakse tühistatud liikumist – ametnik on need elektroonilise valve süsteemist eemaldanud, neid liikumisi ei toimu.</li>
    </ul>
    <p class="py-3">Elektroonilise valve ajakava muudetakse ametniku ja kriminaalhooldusaluse eelneval kokkuleppel. Esmalt kontakteeruge enda ametnikuga ning andke teada enda soovist ajakava muuta. Tooge välja muutmise vajaduse põhjus ning muudatuse ettepanek. Seejärel toimige vastavalt ametniku juhistele. Pange tähele, et kui teavitate ametnikku soovist ajakava muuta ning ametnik sellega nõustub, siis loetakse, et olete antud muudatusega nõus. Muudatuse eraldi kinnitamist ei toimu. Siia ilmub Teie soovitud muudatus mustalt.</p>
    <p class="py-3">Elektroonilise valve nõuete rikkumiseks loetakse elektroonilise valve aktiivsest ajakavast kõrvalekaldumist, seetõttu palun kontrollige alati eelnevalt elektroonilise valve ajakavast üle oma liikumine.</p>`,
            lehePaiseTekstLuhendatud: `<p class="pt-3"></p>Siin näete elektroonilise valve kehtivat ajakava. Elektrooniline valve on kriminaalhooldusalusele kohtu poolt määratud tähtajaks pandud kohustus alluda liikumisvabaduse piirangutele. Ametnik koostab koostöös Teiega elektroonilise valve ajakava...`,
        }
    },
    mixins: [mixin],
    methods: {
        async scrollToEv() {
            await nextTick();
            if (this.$route.params.ajakavaRidaId && document.getElementById(this.$route.params.ajakavaRidaId as string)) {
                document.getElementById(this.$route.params.ajakavaRidaId as string)?.scrollIntoView({ block: "center" });
            }
        },
        item_class(item: any): any {
            return {
                class: {
                    'text-decoration-line-through': item.item.onTyhistatud,
                    'text-disabled': item.item.onAjalooline,
                    'font-weight-bold': !item.item.onAjalooline && item.item.muudetudPealeAjakavaKinnitamist
                }
            };
        },
        rida_class(item: any): any {
            return {
                class: {
                    'valitudRida': +this.$route.params.ajakavaRidaId === +item.item.id
                }
            };
        },
        kinnitaEVAjakava(ev: ElektroonilineValve) {
            this.kinnitamisedIsLoading = true;
            _elektroonilineValveTeenus.kinnitaElektroonilineValveAjakava(ev.id as number).then(() => {
                ev.hooldusaluseKinnitamiseKp = moment();
                this.minuEVAjakava(false);
            }).finally(() => {
                this.kinnitamisedIsLoading = false;
            });
        },
        minuEVAjakava(nahtavUmberlaadimine: boolean = true) {
            this.isLoading = nahtavUmberlaadimine;
            let promise = _elektroonilineValveTeenus.minuElektroonilineValveAjakava();

            promise.then((ajakava) => {



                this.tabelid = ajakava.map((element) => {
                    return {
                        laiendatud: this.$route.params.ajakavaRidaId && element.tegevused.some(x => Number(x.id) === Number(this.$route.params.ajakavaRidaId)) ? [element.id] : [],
                        paised: [
                            {
                                title: 'Ajakava nr.',
                                sortable: false,
                                width: 130,
                                key: 'ajakavaNr',
                                headerProps: {
                                    class: 'v-theme--VokTeema bg-primary text-no-wrap'
                                },
                            },
                            {
                                title: 'Periood',
                                sortable: false,
                                width: 240,
                                key: 'periood',
                                headerProps: {
                                    class: 'v-theme--VokTeema bg-primary text-no-wrap'
                                },
                            },
                            {
                                title: 'Kinnitamise kp.',
                                sortable: false,
                                width: 240,
                                key: 'hooldusaluseKinnitamiseKp',
                                headerProps: {
                                    class: 'v-theme--VokTeema bg-primary text-no-wrap'
                                },
                            }
                        ],
                        suureEkraanipaised: [
                            {
                                title: '',
                                key: 'data-table-expand',
                                headerProps: {
                                    class: 'v-theme--VokTeema bg-primary'
                                }
                            },
                            {
                                title: 'Ajakava nr.',
                                sortable: false,
                                width: 130,
                                key: 'ajakavaNr',
                                headerProps: {
                                    class: 'v-theme--VokTeema bg-primary text-no-wrap'
                                },
                            },
                            {
                                title: 'Periood',
                                sortable: false,
                                width: 240,
                                key: 'periood',
                                headerProps: {
                                    class: 'v-theme--VokTeema bg-primary text-no-wrap'
                                },
                            },
                            {
                                title: 'Kinnitamise kp.',
                                sortable: false,
                                //width: 240,
                                key: 'hooldusaluseKinnitamiseKp',
                                headerProps: {
                                    class: 'v-theme--VokTeema bg-primary text-no-wrap'
                                },
                            }
                        ],
                        sisuPaised: [
                            {
                                title: 'Kuupäev',
                                width: 100,
                                sortable: false,
                                key: 'kuupaev',
                                headerProps: {
                                    class: 'v-theme--VokTeema bg-primary text-no-wrap'
                                },
                            },
                            {
                                title: 'Päev',
                                width: 50,
                                sortable: false,
                                key: 'nadalaPaev',
                                headerProps: {
                                    class: 'v-theme--VokTeema bg-primary text-no-wrap'
                                },
                            },
                            {
                                title: 'Algus',
                                width: 70,
                                sortable: false,
                                key: 'algus',
                                headerProps: {
                                    class: 'v-theme--VokTeema bg-primary text-no-wrap'
                                },
                            },
                            {
                                title: 'Lõpp',
                                width: 70,
                                sortable: false,
                                key: 'lopp',
                                headerProps: {
                                    class: 'v-theme--VokTeema bg-primary text-no-wrap'
                                },
                            },
                            {
                                title: 'Liikumise kirjeldus',
                                width: 300,
                                sortable: false,
                                key: 'tegevuseSisu',
                                headerProps: {
                                    class: 'v-theme--VokTeema bg-primary text-no-wrap'
                                },
                            },
                        ],
                        element: element,
                        tegevused: element.tegevused,
                        lehePikkus: -1
                    }
                });
            }).finally(() => {
                this.isLoading = false;
            });
        }
    },
    mounted() {
        this.minuEVAjakava();
    }
});
</script>
